import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
@Component({
    name: 'provider-table',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class ProviderTable extends Vue {

    // ----------------------------------------------------------
    // Properties

    private tableData: any = [
        {
            application: 'Power BI',
            provider: 'Eureka Math, Lexia, SCALE',
            subject: 'Math, Science, ELA',
            grade: '6-12',
            time: 'Last one year',
            event: '2.6M events <br> 18 May 2020',
        },
        {
            application: 'Navigator',
            provider: 'All',
            subject: 'All',
            grade: 'K-12',
            time: 'All',
            event: '10M events <br> 20 July 2020',
        },
        {
            application: 'Educational MIS',
            provider: 'All',
            subject: 'All',
            grade: 'K-12',
            time: 'Last one year',
            event: '3.8M events <br> 20 July 2020',
        },
    ];


    // ------------------------------------------------------------------
    // Actions

    public swithComponent(activeComp: any) {
       this.$emit('onSwitch', activeComp);
    }

    // ------------------------------------------------------------------------
    // methods


}
